import { render, staticRenderFns } from "./StoryModal.vue?vue&type=template&id=a15a8fa6&scoped=true"
import script from "./StoryModal.vue?vue&type=script&lang=ts"
export * from "./StoryModal.vue?vue&type=script&lang=ts"
import style0 from "./StoryModal.vue?vue&type=style&index=0&id=a15a8fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15a8fa6",
  null
  
)

export default component.exports